export interface RoleDefinition {
  id: number;
  name: string;
  capabilities: Record<string, boolean>;
}

let cachedDefinitions: RoleDefinition[] | null = null;

export function getCachedRoleDefinitions(): RoleDefinition[] | null {
  return cachedDefinitions;
}

export function setCachedRoleDefinitions(definitions: RoleDefinition[]): void {
  cachedDefinitions = definitions;
}

export function clearRoleDefinitionsCache(): void {
  cachedDefinitions = null;
}
